import { useState } from "react";
import { toast } from "sonner";
import { Smartphone } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { mobileInput, mobileProps, MobileHint } from "@/lib/india";
import { OtpBox } from "@/components/OtpBox";

const digits = (v) => v.replace(/\D/g, "").slice(-10);

export const ChangeMobile = ({ who = "customer", token, current, onDone, t = (s) => s }) => {
  const [step, setStep] = useState("");
  const [mob, setMob] = useState("");
  const next = () => {
    if (!/^[6-9]\d{9}$/.test(digits(mob))) return toast.error(t("Please enter a 10-digit mobile number."));
    if (digits(mob) === current) return toast.error(t("This is already your mobile number."));
    setStep("code");
  };
  const onOtp = async (otp_token) => {
    const url = who === "partner" ? `/partner/${token}/mobile` : "/auth/mobile";
    try { const { data } = await api.put(url, { mobile: digits(mob), otp_token }); toast.success(t("Mobile number changed")); setStep(""); setMob(""); onDone?.(data); }
    catch (e) { toast.error(errMsg(e)); setStep("enter"); }
  };
  if (!step) return (
    <button type="button" onClick={() => setStep("enter")} data-testid="change-mobile-btn"
      className="flex items-center gap-1 text-sm font-semibold text-[#2E9E6B]"><Smartphone className="h-4 w-4" />{t("Change number")}</button>
  );
  if (step === "code") return <OtpBox mobile={digits(mob)} purpose="change" who={who} t={t} onVerified={onOtp} onBack={() => setStep("enter")} />;
  return (
    <div className="space-y-3 rounded-2xl border-2 border-[#D2E0D8] bg-white p-4" data-testid="change-mobile-panel">
      <p className="font-bold text-[#0D3B2B]">{t("New mobile number")}</p>
      <p className="text-xs text-[#4A6358]">{t("We'll send an SMS code to the new number. Your number changes only after the code is verified.")}</p>
      <input value={mob} onChange={(e) => setMob(mobileInput(e.target.value))} {...mobileProps} placeholder={t("Mobile number")}
        className="h-14 w-full rounded-xl border border-[#D2E0D8] px-4 text-lg" data-testid="change-mobile-input" />
      <MobileHint value={mob} />
      <div className="flex gap-2">
        <button type="button" onClick={() => setStep("")} className="h-12 flex-1 rounded-2xl border-2 border-[#D2E0D8] font-semibold text-[#4A6358]" data-testid="change-mobile-cancel-btn">{t("Cancel")}</button>
        <button type="button" onClick={next} className="h-12 flex-1 rounded-2xl bg-[#0D3B2B] font-bold text-white" data-testid="change-mobile-send-btn">{t("Send SMS code")}</button>
      </div>
    </div>
  );
};
